import { queryClient } from '@/lib/react-query';
import { useUpdateMutationFactory, UseUpdateMutationProps } from '@/lib/react-query/update';
import { WorkOrder } from '@/types';
import { post } from '@/utils/api';
import { featureKeys, featurePath } from '.';

export type UpdateTaskDTO = { task: WorkOrder };

const completeWorkOrder = ({ task }: UpdateTaskDTO) =>
  post<WorkOrder>(`${featurePath}/${task.task_id}/complete`, {}, {});

export const useCompleteWorkOrder = (options?: UseUpdateMutationProps<WorkOrder>) => {
  return useUpdateMutationFactory({
    invalidateKeys: featureKeys,
    mutationFn: completeWorkOrder,
    onSuccess: (data) => {
      if (data?.taskable_type && data?.taskable_id) {
        queryClient.invalidateQueries({
          queryKey: [{ scope: data.taskable_type, entity: 'detail', id: data.taskable_id }],
        });
      }
    },
    ...options,
  });
};
